(function(app) {
    app.provider("tagApi",
    [
        function() {
            this.$get = [
                "crmApiGateway", function(crmApiGateway) {
                    var service = {};

                    //GETs
                    service.getAll = function() {
                        return crmApiGateway.getArray("/Tags");
                    };

                    service.search = function(term) {
                        return crmApiGateway.getArray("/Tags/Search?q=" + term);
                    }

                    //PUTs
                    service.update = function(tag) {
                        return crmApiGateway.put("/Tags/" + tag.Id, tag);
                    };

                    //POSTs
                    service.add = function(tag) {
                        return crmApiGateway.post("/Tags", tag);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line